import { useState } from 'react'
import MyButton from './buttons'
import SearchBar from './search-bar'
import BigFilter, { SearchFilters } from './BigFilter'
import { useTranslation } from 'react-i18next'
import { API_BASE_URL } from '../../services/api'
import { FaFilter } from 'react-icons/fa'

interface SearchResult {
  _id: string
  _source: {
    title: string
    description: string
  }
}

const HomeFilter = () => {
  const { t } = useTranslation()
  const [results, setResults] = useState<SearchResult[]>([])
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const [, setFilters] = useState<SearchFilters>({
    gender: [],
    distance: [],
    location: [],
    iLiveIn: [],
    imLookingFor: [],
  })

  const handleSearch = async (query: string) => {
    try {
      const response = await fetch(`${API_BASE_URL}/search`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query }),
      })
      const data = await response.json()
      setResults(data)
    } catch (error) {
      console.error('Error searching Elasticsearch:', error)
    }
    setIsFilterOpen(false)
  }

  const toggleFilter = () => {
    console.log('Toggling filter, current state:', isFilterOpen)
    setIsFilterOpen(prev => !prev)
  }

  const handleFiltersChange = (newFilters: SearchFilters) => {
    setFilters(newFilters)
  }

  return (
    <>
      <div className='px-2 sm:px-2 w-full'>
        <div className='grid grid-cols-1 md:grid-cols-12 gap-2 sm:gap-2 my-2 sm:my-2'>
          <div className='md:col-span-8 lg:col-span-9 xl:col-span-9'>
            <SearchBar onSearch={handleSearch} className='w-full' />
          </div>

          <div className='md:col-span-4 lg:col-span-3 xl:col-span-3'>
            <MyButton
              variant='anthracite-redpink'
              className='w-full h-full'
              onClick={toggleFilter}
            >
              <FaFilter className='text-base text-white' />
              {t('filter-announces')}
            </MyButton>
          </div>
        </div>

        <div
          className={`transition-all duration-300 ${
            isFilterOpen
              ? 'opacity-100 max-h-[2000px]'
              : 'opacity-0 max-h-0 overflow-hidden'
          }`}
        >
          <BigFilter
            isFilterOpen={isFilterOpen}
            toggleFilter={toggleFilter}
            onFiltersChange={handleFiltersChange}
          />
        </div>

        <div className='search-results grid grid-cols-2 gap-4'>
          {results.map((result: SearchResult) => (
            <div key={result._id} className='bg-white rounded-lg shadow p-4'>
              <h3 className='font-medium text-redpink truncate'>
                {result._source.title}
              </h3>
              <p className='text-sm text-gray-600 truncate'>
                {result._source.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default HomeFilter
